import DenunciaSeleccionada from './DenunciaSeleccionada';

export default DenunciaSeleccionada;
